module.exports = __webpack_public_path__ + "img/img_servicios.edf93582.webp";